// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (c) 2026 Password Manager contributors
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/security")({
	beforeLoad: () => {
		throw redirect({ to: "/features", replace: true });
	},
});
